import {fromJS} from 'immutable';
import CustomRouteReducer from '../model/CustomRouteReducer'
import { combineReducers } from 'redux-immutable';
import UserReducer  from '../model/User/reducer';
import SystemReducer from '../model/System/reducer';
import CompanyReducer from '../model/Company/reducer';
import DiscountReducer from '../model/DiscountCode/reducer';


const appReducer = combineReducers({
  system: SystemReducer,
  routing: CustomRouteReducer,
  user: UserReducer,
  company: CompanyReducer,
  discount: DiscountReducer
})

const rootReducer = (state, action) => {

  if (action.type === 'USER_LOGOUT') {
      let url = state.getIn(['system', 'api'])
      let routing = state.getIn(['routing'])
      state = fromJS({
          'system': {
              'api': url
          },
          'routing': routing
      })
  }

  return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// src/store/rootReducer.js